import React from 'react';
import { 
  LayoutDashboard, 
  Car, 
  Users, 
  MapPin, 
  Clock, 
  BarChart3, 
  Settings,
  Navigation,
  Phone,
  Receipt,
  Wallet,
  Activity,
  Banknote,
  Database,
  FileText,
  ChevronLeft,
  ChevronRight,
  ClipboardCheck,
  UserCircle,
  HandCoins,
  Bell
} from 'lucide-react';

const navItems = [
  { icon: LayoutDashboard, label: 'Përmbledhje', path: '/admin' },
  { icon: MapPin, label: 'Harta Live', path: '/admin/map' },
  { icon: Navigation, label: 'Porositë', path: '/admin/rides' },
  { icon: Activity, label: 'Menaxhimi Udhëtimeve', path: '/admin/rides/operations' },
  { icon: UserCircle, label: 'Shoferët', path: '/admin/drivers' },
  { icon: Car, label: 'Flota e Automjeteve', path: '/admin/fleet' },
  { icon: Users, label: 'Pasagjerët', path: '/admin/passengers' },
  { icon: Bell, label: 'Push Notifications', path: '/admin/push-notifications' },
  { icon: Activity, label: 'Performanca', path: '/admin/performance' },
  { icon: ClipboardCheck, label: 'Verifikim Turnesh', path: '/admin/shift-verification' },
  { icon: Clock, label: 'Turnet', path: '/admin/shifts' },
  { icon: Wallet, label: 'Pagesat', path: '/admin/payments' },
  { icon: HandCoins, label: 'Mandat Arkëtimi', path: '/admin/cash-settlement' },
  { icon: Receipt, label: 'Faturat', path: '/admin/invoices' },
  { icon: Banknote, label: 'Financat', path: '/admin/finance' },
  { icon: Database, label: 'Mbyllja Ditore', path: '/admin/daily-closing' },
  { icon: Navigation, label: 'Rrugë Popullore', path: '/admin/routes' },
  { icon: BarChart3, label: 'Analitika', path: '/admin/analytics' },
  { icon: FileText, label: 'Logs', path: '/admin/logs' },
  { icon: Settings, label: 'Konfigurime', path: '/admin/settings' },
];

// TIA TAXI Logos
const TIA_LOGO = 'https://assets.tiataxi.al/shared/logo-header.png';

export const Sidebar = ({ currentPath, onNavigate, isCollapsed, onToggleCollapse }) => {
  return (
    <aside className={`sidebar-container ${isCollapsed ? 'collapsed' : 'expanded'}`}>
      {/* Logo + Collapse Toggle - Inline */}
      <div className="sidebar-header">
        <div className="sidebar-logo-wrapper">
          {!isCollapsed ? (
            <img 
              src={TIA_LOGO} 
              alt="TIA TAXI" 
              className="h-10 w-auto object-contain"
            />
          ) : (
            <div className="w-10 h-10 rounded-lg bg-amber-500 flex items-center justify-center">
              <span className="text-white font-bold text-sm">TIA</span>
            </div>
          )}
        </div>
        <button 
          onClick={onToggleCollapse}
          className="sidebar-collapse-btn"
          title={isCollapsed ? 'Zgjero menunë' : 'Mbyll menunë'}
        >
          {isCollapsed ? (
            <ChevronRight className="w-5 h-5" />
          ) : (
            <ChevronLeft className="w-5 h-5" />
          )}
        </button>
      </div>

      {/* Menu Label */}
      <div className={`sidebar-menu-label ${isCollapsed ? 'hidden' : ''}`}>
        Menu Kryesor
      </div>

      {/* Main Navigation */}
      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <button
            key={item.path}
            onClick={() => onNavigate(item.path)}
            className={`sidebar-menu-item ${currentPath === item.path ? 'active' : ''}`}
            title={item.label}
          >
            <item.icon className="sidebar-menu-icon" />
            <span className="sidebar-menu-text">{item.label}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
